import React from "react";
import classes from "./FilterShimmer.module.scss";

const ShimmerLine = ({ className }) => (
  <div className={`${classes.shimmer_line} ${className || ""}`} />
);

const OptionRow = ({ widthClass }) => (
  <div className={classes.option_row}>
    <ShimmerLine className={classes.checkbox} />
    <ShimmerLine className={`${classes.label} ${widthClass}`} />
  </div>
);

const FilterShimmer = () => {
  return (
    <div className={classes.filter_shimmer}>
      {/* Price range shimmer */}
      <div className={classes.filter_group}>
        <ShimmerLine className={classes.filter_heading} />
        <div className={classes.range_values}>
          <ShimmerLine className={classes.range_value} />
          <ShimmerLine className={classes.range_value} />
        </div>
        <ShimmerLine className={classes.range_bar} />
      </div>

      {/* Color shimmer */}
      <div className={classes.filter_group}>
        <ShimmerLine className={classes.filter_heading} />
        <div className={classes.color_options}>
          <ShimmerLine className={classes.color_circle} />
          <ShimmerLine className={classes.color_circle} />
          <ShimmerLine className={classes.color_circle} />
        </div>
      </div>

      {/* Checkbox filter groups */}
      {[4, 3, 5, 3].map((count, groupIndex) => (
        <div key={groupIndex} className={classes.filter_group}>
          <ShimmerLine className={classes.filter_heading} />
          <div className={classes.filter_options}>
            {[...Array(count)].map((_, i) => (
              <OptionRow
                key={i}
                widthClass={
                  i % 3 === 0
                    ? classes.label_long
                    : i % 3 === 1
                    ? classes.label_medium
                    : classes.label_short
                }
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilterShimmer;
